import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as RegistrationListService from '../../../services/api/registration_list';

/** Fetch SchemeTypes  */

interface FetchRegistrationListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  status?: string;
  state?: string;
}

class FetchRegistrationList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REGISTRATION_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REGISTRATION_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REGISTRATION_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchRegistrationListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationListService.fetchRegistrationList(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchSchemeTypes Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchRegistrationListAction: (payload: FetchRegistrationListInput) =>
    new FetchRegistrationList().action(payload),
};
